(function () {
  'use strict';

  var MARK = {
    cat:
      '<svg class="dcs__mark is-cat" viewBox="0 0 64 64" aria-hidden="true">' +
        '<g fill="#FFFFFF">' +
          '<path d="M11.5 8.5 L23.8 22.2 C28.2 20.4 35.8 20.4 40.2 22.2 L52.5 8.5 ' +
            'L54.8 28.2 C57 35.6 54.6 45 47.4 50.4 C42.6 54 37.2 55.8 32 55.8 ' +
            'C26.8 55.8 21.4 54 16.6 50.4 C9.4 45 7 35.6 9.2 28.2 Z"/>' +
        '</g>' +
        '<g fill="#00897A">' +
          '<ellipse cx="24.2" cy="33.4" rx="2.8" ry="3.8"/>' +
          '<ellipse cx="39.8" cy="33.4" rx="2.8" ry="3.8"/>' +
          '<path d="M28.8 41.2 L35.2 41.2 L32 45.2 Z"/>' +
        '</g>' +
      '</svg>',
    dog:
      '<svg class="dcs__mark is-dog" viewBox="0 0 64 64" aria-hidden="true">' +
        '<g fill="#FFFFFF">' +
          '<path d="M20 19 C9 20 3 32 6 43 C8 50.5 17 50.5 19.5 42 C17 34 17.5 25 20 19 Z"/>' +
          '<path d="M44 19 C55 20 61 32 58 43 C56 50.5 47 50.5 44.5 42 C47 34 46.5 25 44 19 Z"/>' +
          '<path d="M32 11 C42 11 46.5 20 46.5 29.5 C46.5 35.5 44.5 40.5 41 44 ' +
            'C38 49.5 35.5 53.5 32 53.5 C28.5 53.5 26 49.5 23 44 ' +
            'C19.5 40.5 17.5 35.5 17.5 29.5 C17.5 20 22 11 32 11 Z"/>' +
        '</g>' +
        '<g fill="#DD9933">' +
          '<circle cx="25.5" cy="29" r="2.8"/>' +
          '<circle cx="38.5" cy="29" r="2.8"/>' +
          '<ellipse cx="32" cy="44" rx="4.6" ry="3.6"/>' +
        '</g>' +
      '</svg>'
  };

  function init(root) {
    if (!root || root.dataset.dcsReady === '1') return;
    var payload = window.DCS_DATA;
    if (!payload) return;
    root.dataset.dcsReady = '1';

    var D = payload.D, P = payload.P, LB = payload.LB, COUNTS = payload.COUNTS;
    var NS = 'http://www.w3.org/2000/svg';

    var M = {};
    D.forEach(function (d) {
      M[d[0]] = { code: d[0], name: d[1], cats: d[2], dogs: d[3], inc: d[4], exc: d[5] };
    });

    function fmt(n) { return n.toLocaleString('en-US'); }
    function isCat(s) { return s.cats > s.dogs; }
    function pct(s) { return s.cats / (s.cats + s.dogs) * 100; }
    function q(sel) { return root.querySelector(sel); }

    function setAll(sel, v) {
      root.querySelectorAll(sel).forEach(function (e) { e.textContent = v; });
    }

    var totalCats = D.reduce(function (a, d) { return a + d[2]; }, 0);
    var totalDogs = D.reduce(function (a, d) { return a + d[3]; }, 0);

    setAll('[data-dcs="cats"]', fmt(totalCats));
    setAll('[data-dcs="dogs"]', fmt(totalDogs));
    setAll('[data-dcs="f-inc"]', fmt(COUNTS.included));
    setAll('[data-dcs="f-exc"]', fmt(COUNTS.generic));
    setAll('[data-dcs="f-nod"]', fmt(COUNTS.nodata));
    setAll('[data-dcs="f-tot"]', fmt(COUNTS.total));

    var tip = root.querySelector('.dcs__tip');
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'dcs__tip';
      tip.setAttribute('role', 'status');
      tip.setAttribute('aria-live', 'polite');
      root.appendChild(tip);
    }

    function showTip(s, x, y) {
      var cat = isCat(s);
      var share = cat ? pct(s) : 100 - pct(s);
      var shelters = s.inc === 1 ? '1 shelter counted' : fmt(s.inc) + ' shelters counted';

      tip.innerHTML =
        '<div class="dcs__tiphead">' +
          (cat ? MARK.cat : MARK.dog) +
          '<div>' +
            '<div class="dcs__tipname">' + s.name + '</div>' +
            '<div class="dcs__tipverdict ' + (cat ? 'is-cat' : 'is-dog') + '">is a ' +
              (cat ? 'cat' : 'dog') + ' state</div>' +
          '</div>' +
        '</div>' +
        '<div class="dcs__tipbar">' +
          '<i class="bc" style="width:' + pct(s) + '%"></i>' +
          '<i class="bd" style="width:' + (100 - pct(s)) + '%"></i>' +
        '</div>' +
        '<div class="dcs__tipnums">' +
          '<span class="nc">' + fmt(s.cats) + ' cats</span>' +
          '<span class="nd">' + fmt(s.dogs) + ' dogs</span>' +
        '</div>' +
        '<div class="dcs__tipfoot">' +
          share.toFixed(1) + '% ' + (cat ? 'cats' : 'dogs') + ' &middot; ' + shelters +
        '</div>';

      tip.classList.add('is-on');
      moveTip(x, y);
    }

    function moveTip(x, y) {
      var r = tip.getBoundingClientRect();
      var l = x + 18, t = y + 18;
      if (l + r.width > window.innerWidth - 10) l = x - r.width - 18;
      if (t + r.height > window.innerHeight - 10) t = y - r.height - 18;
      tip.style.left = Math.max(8, l) + 'px';
      tip.style.top = Math.max(8, t) + 'px';
    }
    function hideTip() { tip.classList.remove('is-on'); }

    function bind(el, s) {
      el.addEventListener('mouseenter', function (e) { showTip(s, e.clientX, e.clientY); });
      el.addEventListener('mousemove', function (e) { moveTip(e.clientX, e.clientY); });
      el.addEventListener('mouseleave', hideTip);
      el.addEventListener('focus', function () {
        var r = el.getBoundingClientRect();
        showTip(s, r.left + r.width / 2, r.bottom - 8);
      });
      el.addEventListener('blur', hideTip);
    }

    function label(s) {
      return s.name + ', ' + (isCat(s) ? 'cat state' : 'dog state') + '. ' +
        fmt(s.cats) + ' cats saved, ' + fmt(s.dogs) + ' dogs saved, ' +
        s.inc + ' shelters counted.';
    }

    var G = {};
    var svg = q('.dcs__map');
    if (svg) {
      var gS = document.createElementNS(NS, 'g');
      var gL = document.createElementNS(NS, 'g');
      svg.appendChild(gS); svg.appendChild(gL);

      Object.keys(P).forEach(function (code) {
        var s = M[code]; if (!s) return;
        var cat = isCat(s), L = LB[code];

        var g = document.createElementNS(NS, 'g');
        g.setAttribute('class', 'dcs__sg');
        g.setAttribute('tabindex', '0');
        g.setAttribute('role', 'img');
        g.setAttribute('aria-label', label(s));

        var p = document.createElementNS(NS, 'path');
        p.setAttribute('d', P[code]);
        p.setAttribute('class', 'dcs__st ' + (cat ? 'is-cat' : 'is-dog'));
        g.appendChild(p);
        gS.appendChild(g);
        bind(g, s);
        G[code] = g;

        function marginEntry(y, only, lx) {
          var g2 = document.createElementNS(NS, 'g');
          g2.setAttribute('class', only);

          var hh = only === 'dcs--mobonly' ? 44 : 30;
          var hw = code === 'HI' ? 42 : 62;
          var hit = document.createElementNS(NS, 'rect');
          hit.setAttribute('x', lx - 18);
          hit.setAttribute('y', y - hh / 2);
          hit.setAttribute('width', hw);
          hit.setAttribute('height', hh);
          hit.setAttribute('class', 'dcs__ohit');
          g2.appendChild(hit);
          bind(g2, s);

          var line = document.createElementNS(NS, 'polyline');
          line.setAttribute('points',
            L.cx + ',' + L.cy + ' ' + (lx - 28) + ',' + y + ' ' + (lx - 14) + ',' + y);
          line.setAttribute('class', 'dcs__leader');
          g2.appendChild(line);

          var dot = document.createElementNS(NS, 'circle');
          dot.setAttribute('cx', lx - 8);
          dot.setAttribute('cy', y);
          dot.setAttribute('r', 4.5);
          dot.setAttribute('class', 'dcs__odot ' + (cat ? 'is-cat' : 'is-dog'));
          g2.appendChild(dot);

          var ot = document.createElementNS(NS, 'text');
          ot.setAttribute('x', lx + 2);
          ot.setAttribute('y', y + 4);
          ot.setAttribute('class', 'dcs__olab');
          ot.textContent = code;
          g2.appendChild(ot);

          gL.appendChild(g2);
        }

        if (!L.dm) {
          var t = document.createElementNS(NS, 'text');
          t.setAttribute('x', L.cx);
          t.setAttribute('y', L.cy + 3.5);
          t.setAttribute('text-anchor', 'middle');
          t.setAttribute('class',
            'dcs__slab t-' + L.t + (L.mm ? ' dcs--deskonly' : ''));
          t.textContent = code;
          gL.appendChild(t);
        }
        if (L.dm) marginEntry(L.dy, 'dcs--deskonly', L.lx);
        if (L.mm) marginEntry(L.my, 'dcs--mobonly', L.mx);
      });
    }

    var picked = null;
    var ring = null;
    if (svg) {
      ring = document.createElementNS(NS, 'path');
      ring.setAttribute('class', 'dcs__ring');
      ring.style.display = 'none';
      svg.insertBefore(ring, svg.lastChild);
    }
    function unpick() {
      if (picked) picked.classList.remove('is-picked');
      if (ring) ring.style.display = 'none';
      picked = null;
    }
    function pick(code) {
      var g = G[code], s = M[code];
      if (!g || !s) return;
      unpick();
      picked = g;
      g.classList.add('is-picked');
      if (ring) { ring.setAttribute('d', P[code]); ring.style.display = ''; }
      var r = g.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) {
        window.scrollBy(0, r.top + r.height / 2 - window.innerHeight / 2);
        r = g.getBoundingClientRect();
      }
      showTip(s, r.left + r.width / 2, r.bottom - 8);
    }

    var sel = q('.dcs__select');
    if (sel) {
      D.slice().sort(function (a, b) { return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0; })
        .forEach(function (d) {
          var o = document.createElement('option');
          o.value = d[0];
          o.textContent = d[1];
          sel.appendChild(o);
        });
      sel.addEventListener('change', function () {
        if (sel.value) pick(sel.value); else { unpick(); hideTip(); }
      });
    }

    document.addEventListener('click', function (e) {
      if (!picked) return;
      var t = e.target.closest ? e.target : e.target.parentNode;
      if (t.closest('.dcs__select')) return;
      unpick();
      if (sel) sel.value = '';
      if (!t.closest('.dcs__sg, .dcs__brow, .dcs--mobonly, .dcs--deskonly')) hideTip();
    });

    var bars = q('.dcs__bars');
    if (bars) {
      var alpha = D.slice().sort(function (a, b) { return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0; });

      alpha.forEach(function (d) {
        var s = M[d[0]];
        var pc = pct(s);
        var row = document.createElement('div');
        row.className = 'dcs__brow';
        row.tabIndex = 0;
        row.setAttribute('aria-label', label(s));
        row.innerHTML =
          '<span class="dcs__bcode">' +
            '<span class="full">' + s.name + '</span>' +
            '<span class="abbr">' + s.code + '</span>' +
          '</span>' +
          '<span class="dcs__track">' +
            '<span class="dcs__seg-cat" style="width:' + pc + '%"></span>' +
            '<span class="dcs__seg-gap"></span>' +
            '<span class="dcs__seg-dog" style="width:' + (100 - pc) + '%"></span>' +
          '</span>';
        bind(row, s);
        bars.appendChild(row);
      });

      var mid = q('.dcs__midline');
      var placeMid = function () {
        var track = bars.querySelector('.dcs__track');
        var box = q('.dcs__barsbox');
        if (!track || !mid || !box) return;
        var br = box.getBoundingClientRect();
        var tr = track.getBoundingClientRect();
        mid.style.left = (tr.left - br.left + tr.width / 2) + 'px';
      };
      placeMid();
      window.addEventListener('resize', placeMid);
    }
  }

  function boot() {
    document.querySelectorAll('.dcs').forEach(function (el) { init(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.dcs') : null;
    if (el) init(el);
  });
})();
